import { render, staticRenderFns } from "./Activar.vue?vue&type=template&id=13c6443a"
import script from "./Activar.vue?vue&type=script&lang=js"
export * from "./Activar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports